import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	adminSpotlightTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.admin-spotlight-title',
		defaultMessage: 'Save and reset your list view',
		description: 'Title for the onboarding spotlight of the new saved views dropdown in List view.',
	},
	adminSpotlightMessage: {
		id: 'issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.admin-spotlight-message',
		defaultMessage:
			'<p>Saved views are now in list view.</p><p>Save your view for everyone in the project or reset it back to the default settings.</p>',
		description:
			'Body for the onboarding spotlight of the new saved views dropdown in the List view.',
	},
	spotlightTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.spotlight-title',
		defaultMessage: 'Reset your view',
		description:
			'Title for the onboarding spotlight of the new saved views dropdown in the List view.',
	},
	spotlightMessage: {
		id: 'issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.spotlight-message',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			"<p>Saved views are now in list view. Your admin set up a view to help make collaboration easier.</p><p>You can make changes to your view or reset to the admin's view anytime.</p>",
		description:
			'Body for the onboarding spotlight of the new saved views dropdown in the List view.',
	},
	spotlightLearnMoreButton: {
		id: 'issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.spotlight-learn-more-button',
		defaultMessage: 'More about saved views',
		description: 'Label for the learn more button in the saved views spotlight.',
	},
	spotlightDismissButton: {
		id: 'issue-navigator-save-reset-view-settings-button.SavedViewsOnboarding.messages.spotlight-dismiss-button',
		defaultMessage: 'OK',
		description: 'Label for dismiss button to close the spotlight.',
	},
});
